import type { ImageProps } from "@/types";

/**
 * Image Component
 * Optimized image component with responsive support
 * Integrates with Storyblok Image Service
 */
export const Image = ({
  src,
  alt,
  width,
  height,
  className = '',
  priority = false,
  fill = false,
}: ImageProps) => {
  // If fill is true, use object-cover for full container coverage
  if (fill) {
    return (
      <img
        src={src}
        alt={alt}
        className={`w-full h-full object-cover ${className}`}
        loading={priority ? undefined : 'lazy'}
      />
    );
  }

  // Standard image with width/height
  return (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      className={className}
      loading={priority ? undefined : 'lazy'}
    />
  );
};

export default Image;
